var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',{attrs:{"height":_vm.containerHeight,"width":_vm.containerWidth}},_vm._l((_vm.cardDimensions),function(cardDimension,index){return _c('rect',_vm._b({key:("card_" + index)},'rect',cardDimension,false))}),0)}
var staticRenderFns = []

export { render, staticRenderFns }